import React from 'react'
import { string, shape, bool } from 'prop-types'
import { Controller } from 'react-hook-form'

import Input from '@components/Input'
import ReactInputMask from 'react-input-mask'
import TextField from './DynamicInput.style'

export default function DynamicInput({ field, disabled, errors, control }) {
  const hasMask = field.options && field.options.mask
  const id = `dynamic-input-${field.id}`

  if (hasMask) {
    return (
      <div
        id={id}
        data-testid="dynamic-form-input-format"
        style={{
          visibility: field.visibility ? field.visibility : 'visible',
        }}
      >
        <Controller
          as={ReactInputMask}
          label={field.label}
          name={field.name}
          control={control}
          mask={field.options.mask}
          onBlur={field.actions && field.actions.onBlur}
          defaultValue=""
          disabled={disabled}
          errorMessage={errors && errors.message}
        >
          {({ label, name, errorMessage, reference }) => (
            <TextField
              label={label}
              name={name}
              variant="outlined"
              inputRef={reference}
              helperText={errorMessage}
            />
          )}
        </Controller>
      </div>
    )
  }
  return (
    <div
      id={id}
      data-testid="dynamic-form-input"
      style={{
        visibility: field.visibility ? field.visibility : 'visible',
      }}
    >
      <Controller
        as={Input}
        name={field.name}
        label={field.label}
        control={control}
        disabled={disabled}
        onBlur={field.actions && field.actions.onBlur}
        onChange={field.actions && field.actions.onChange}
        errorMessage={errors && errors.message}
        defaultValue=""
      />
    </div>
  )
}

DynamicInput.propTypes = {
  field: shape({
    label: string,
    name: string,
  }).isRequired,
  control: shape({}).isRequired,
  disabled: bool,
  errors: shape({}),
}

DynamicInput.defaultProps = {
  disabled: false,
  errors: {},
}
